<template>
  <div id="app-sidenav" class="col-2 my-4 fixed-top flex-column z-index-2" style="left: 16px; right: 16px;">
    <div class="sidenav navbar navbar-vertical px-0 border-radius-xl flex-grow-1 bg-white pt-0 pb-2">
        <div class="w-90 my-4 mx-auto">
          <router-link class="text-center d-block" to="/">
            <img :src="logo" class="logo" alt="outletarredamento.it" />
          </router-link>
        </div>
        <div class="divider w-90 mx-auto mb-4">
         
          <p class="text-center small mb-0">Annunci attivi:</p>
          <p class="text-dark text-bold text-center mb-0" id="active-insertions" ref="activeInsertions">{{this.active}}</p>
          
        </div>
        <sidenav-list />
        <side-user />
        <div class="w-90 mx-auto mb-4 d-none">
        <p class="text-center small mb-0">© {{ currentYear }} - Versione 3.1.2</p>
        </div>
        
      </div>
  </div>
</template>
<script>
import logger from "@/utils/logger";
import SidenavList from "./SidenavList.vue";
import SideUser from "./SideUser.vue";
import logo from "@/assets/img/logo.svg";
import VueCookies from 'vue-cookies';

export default {
  name: "index",
  setup() {
    const {log} = logger();
    return {
      log
    }
  },
  components: {
    SidenavList,
    SideUser
  },
  data() {
    return {
      logo,
      active: 0,
      seller: {},
    };
  },
  props: ["layout"],
  mounted() {    
    // this.active = $store.state.activeAds vecchio medoto
    // this.active = VueCookies.get('seller').schede_attive
    setTimeout(() => {
        const seller = VueCookies.get('seller');

        if (seller && seller.schede_attive) {
            this.active = seller.schede_attive;
        } else {
            console.warn("Il cookie 'seller' è nullo o non contiene 'schede_attive'");
            this.active = 'Il cookie seller è nullo o non contiene schede_attive'; // Valore di default
        }
    }, 1000);
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  }
};
</script>
<style scoped>
.divider {border-bottom: 2px solid #d2d6da;}
</style>